export default __webpack_public_path__ + "static/media/person_1@3x.b09b3088.png";